export const SET_STORES = "SET_STORES";
export const SELECT_STORE = "SELECT_STORE";
export const SET_EVENTS = "SET_EVENTS";
export const SELECT_EVENT = "SELECT_EVENT";
export const SET_ERROR = "SET_ERROR";
export const RESET_ERROR = "RESET_ERROR";
export const SELECT_TIMESLOT = "SELECT_TIMESLOT";
export const SET_USER = "SET_USER";
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const SET_EVENT = "SET_EVENT";
